module.exports = __webpack_public_path__ + "media/images/hitfun/icon.search.gray-dcafa87e3d5b496210968a8fc2f82b7c.svg";